<template>
  <div class="flex_x_cen header">
     <div class="logo" style="display: flex;gap: 10px;">
      <div v-show="isReturn" @click="returnLiyuan" class="r_pub_button_retrun">
        {{ lang.Return }}
      </div>
      <!-- <img v-if="!controlsObj" src="@/assets/img/appCenter/cocoFlow.svg" alt="logo" style="width: 100%" /> -->
<!--			<img v-if="!user.is_table && controlsObj && controlsObj.logoUrl && user.type !== USER_TYPE_CONSTANTS.STUDENT_TYPE" :src="controlsObj.logoUrl" alt="logo" style="height: 100%;" />-->
    </div>
    <div class="flex_x_item">
      <div
        v-for="(item, index) in header_tab_list2"
        :key="index"
        class="mr-20"
        @click="checkTab(item)"
        v-show="!(item.value==3 && ['com','hk'].includes(user.orgArea))"
      >
        <div
          class="flex_x_item tabItem"
          :class="
            item.value == active_header_tab ? 'active-header-tab' : 'header-tab'
          "
        >
					<img :src="item.value==active_header_tab?item.active:item.default">
          <div v-if="item.value==active_header_tab">{{item.activeName}}</div>
          <div v-else>{{item.defaultName}}</div> 
        </div>
      </div>
    </div>
    <div v-if="active_header_tab==0" class="location flex_x_item" >
      <img src="@/assets/img/appCenter/index_header_location.svg" />
      <el-select
        v-model="user.orgArea"
        style="width: 80px"
        class="location_select"
        @change="handle_change_orgArea"
      >
        <el-option
          v-for="item in lang.area_list"
          :key="item.name"
          :label="item.name"
          :value="item.label"
        >
        </el-option>
      </el-select>
      <div v-show="islogout && active_header_tab==0" @click="logout" class="logout_btn">
        {{ lang.logout }}
      </div>
      <!-- <div v-show="isReturn" @click="returnLiyuan" class="logout_btn">
        {{ lang.Return }}
      </div> -->
    </div>
    <!-- <div v-else class="location flex_x_item" >
      <div v-show="isReturn" @click="returnLiyuan" class="logout_btn">
        {{ lang.Return }}
      </div>
    </div> -->
  </div>
</template>
<script>
import { myMixin } from "@/common/mixin.js";
import { isRestrictedOrg } from '@/common/org.js';
import { ORGANIZATION_CONSTANTS, USER_TYPE_CONSTANTS } from '@/common/constants.js';

export default {
  name: 'homeHeader',
  mixins: [myMixin],
  props:{
    active_header_tab: Number,
  },
  watch:{
    active_header_tab(newValue){
      console.log(newValue)
      // if(newValue===1){
      //   this.header_tab_list[1].name=this.lang.createSpace
      // }else{
      //   this.header_tab_list[1].name=this.lang.create_app
      // }
    }
  },
  computed: {
    header_tab_list2() {
			let _list = this.header_tab_list;
			if(!this.studentSpace.includes(this.user.organizeid) && !this.studentSpace.includes(this.user.org)){
				_list = _list.filter(item => item.value !== 5)
			}
			if(!this.teacherSpace.includes(this.user.organizeid) && !this.teacherSpace.includes(this.user.org)){
				_list = _list.filter(item => item.value !== 4)
			}

			if(['eed08ac6-7269-11f0-9c7b-005056924926'].includes(this.user.org)){
				_list = _list.filter(item => item.value !== 3)
			}

			// 如果用户类型为2(学生)，只保留创建应用(value:1)和知识管理(value:2)
      console.log('this.userthis.userthis.userthis.userthis.userthis.user',this.user);
      
			if(this.user?.type === 2){
        // 荔园有应用中心创建应用(value:0)
        if (this.liyuanlist.includes(this.user.org)) {
            _list = _list?.filter?.(item => item?.value === 1 || item?.value === 2 || item?.value === 0) 
        }else{
            _list = _list?.filter?.(item => item?.value === 1 || item?.value === 2)
        }
			}

      if (isRestrictedOrg(this.user.organizeid)) {
        _list = _list.filter((item) =>
          ORGANIZATION_CONSTANTS.LIMIT_HEADER_TAB_VALUES.includes(item.value)
        );
      }
			return _list;
      // return this.user.organizeid == '45facc0a-1211-11ec-80ad-005056b86db5' ? this.header_tab_list : this.header_tab_list.filter(item => item.value !== 4 && item.value !== 5)
    }
  },
  data() {
    return {
      liyuanlist:[
						"3823a6a5-1b6e-11f0-a66a-005056924926",
						"292e34dc-1b6e-11f0-a66a-005056924926",
						"21d6b367-1b6e-11f0-a66a-005056924926",
						"1a1a172d-1b6e-11f0-a66a-005056924926",
						"1197f86b-1b6e-11f0-a66a-005056924926",
						"f235659b-1b6d-11f0-a66a-005056924926",
						"d87b62d3-1b6d-11f0-a66a-005056924926",
						"c25ea59b-1b6d-11f0-a66a-005056924926",
			],
      header_tab_list: [
        {
          name: this.lang.app_center,
          activeName:this.lang.app_center,
          defaultName:this.lang.appSelection,
					active:require("@/assets/img/appCenter/appCenter_active.svg"),
					default:require("@/assets/img/appCenter/appCenter_default.svg"),
          icon: `cocoflow-quanbu`,
					value:0,
        },
        // {
        //   name: this.lang.agent,
				// 	active:require("@/assets/img/appCenter/agent_active.svg"),
				// 	default:require("@/assets/img/appCenter/agent_default.svg"),
        //   icon: `cocoflow-zhinengti`,
        // },
        // {
        //   name: this.lang.workflow,
				// 	active:require("@/assets/img/appCenter/workflow_active.svg"),
				// 	default:require("@/assets/img/appCenter/workflow_default.svg"),
        //   icon: 'cocoflow-gongzuoliuquanjugongxiang'
        // },
				{
					name:this.lang.creativeSpace,
          activeName:this.lang.creativeSpace,
          defaultName:this.lang.create_app,
					active:require("@/assets/img/appCenter/workflow_active.svg"),
					default:require("@/assets/img/appCenter/workflow_default.svg"),
          icon: 'cocoflow-gongzuoliuquanjugongxiang',
					value:1,
				},
				{
					name:this.lang.knowledgeBase2,
          activeName:this.lang.knowledgeBase2,
          defaultName:this.lang.knowledgeBase2,
					active:require("@/assets/img/appCenter/knowledgeBase_active.svg"),
					default:require("@/assets/img/appCenter/knowledgeBase_default.svg"),
          icon: 'cocoflow-gongzuoliuquanjugongxiang',
					value:2,
				},
				{
					name:this.lang.teaching_mode,
          activeName:this.lang.teaching_mode,
          defaultName:this.lang.startTeaching,
					active:require("@/assets/img/appCenter/teaching_mode_active.svg"),
					default:require("@/assets/img/appCenter/teaching_mode_default.svg"),
          icon: 'cocoflow-gongzuoliuquanjugongxiang',
					value:4,
				},
        {
          name: this.lang.studySpace,
          activeName:this.lang.studySpace,
          defaultName:this.lang.selfLearning,
					active:require("@/assets/img/appCenter/learning_active.svg"),
					default:require("@/assets/img/appCenter/learning_default.svg"),
          icon: 'cocoflow-gongzuoliuquanjugongxiang',
					value:5,
        },
				{
          name: this.lang.AIappSelection,
          activeName:this.lang.AIappSelection,
          defaultName:this.lang.AIappSelection,
					active:require("@/assets/img/appCenter/appCenter_active.svg"),
					default:require("@/assets/img/appCenter/appCenter_default.svg"),
          icon: 'cocoflow-gongzuoliuquanjugongxiang',
					value:3,
        },
//         {
//           name: this.lang.knowledgeBase2,
//           icon: `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
// <path fill-rule="evenodd" clip-rule="evenodd" d="M3.125 5.20449V12.8898C3.88006 12.347 4.93828 11.875 6.25 11.875C7.98616 11.875 9.18544 12.4307 10 13.0067V4.72775C9.28675 4.33372 7.8498 3.75 6.25 3.75C4.6626 3.75 3.55859 4.66456 3.125 5.20449ZM11.25 4.66924V12.7121C11.9594 12.2359 12.9833 11.875 14.375 11.875C16.0183 11.875 17.2732 12.3734 18.125 12.9438V5.11968C17.9356 4.72271 17.1235 3.75 15 3.75C12.9659 3.75 11.7342 4.33149 11.25 4.66924ZM10.5741 3.61727C9.69555 3.13803 8.07437 2.5 6.25 2.5C3.9877 2.5 2.47947 3.90407 1.97997 4.65331C1.91152 4.75598 1.875 4.87661 1.875 5V14.375C1.875 14.6504 2.05529 14.8934 2.31888 14.9732C2.58248 15.053 2.86726 14.9508 3.02003 14.7217C3.35387 14.2209 4.5123 13.125 6.25 13.125C8.49114 13.125 9.58812 14.222 10.1796 14.8135L10.1831 14.8169C10.3362 14.9701 10.5578 15.033 10.7686 14.9833C10.9794 14.9335 11.1494 14.7781 11.2179 14.5726C11.3265 14.2468 12.0946 13.125 14.375 13.125C16.6656 13.125 17.929 14.2702 18.23 14.7217C18.3827 14.9508 18.6675 15.053 18.9311 14.9732C19.1947 14.8934 19.375 14.6504 19.375 14.375V5C19.375 4.93282 19.3642 4.86609 19.3429 4.80236C19.0349 3.8782 17.7196 2.5 15 2.5C12.8373 2.5 11.3454 3.09319 10.5741 3.61727Z" fill="black" fill-opacity="0.9"/>
// <path fill-rule="evenodd" clip-rule="evenodd" d="M1.97996 16.5283C2.47946 15.7791 3.98769 14.375 6.24999 14.375C8.37365 14.375 9.69404 15.2064 10.4896 15.8894C11.1268 15.125 12.3688 14.375 14.375 14.375C17.0844 14.375 18.7377 15.7298 19.27 16.5283C19.4615 16.8155 19.3839 17.2036 19.0967 17.395C18.8095 17.5865 18.4214 17.5089 18.23 17.2217C17.929 16.7702 16.6656 15.625 14.375 15.625C12.0946 15.625 11.3265 16.7468 11.2179 17.0726C11.1494 17.2781 10.9794 17.4335 10.7686 17.4833C10.5578 17.533 10.3362 17.4701 10.183 17.3169L10.1796 17.3135C9.58811 16.722 8.49113 15.625 6.24999 15.625C4.51229 15.625 3.35386 16.7209 3.02002 17.2217C2.82855 17.5089 2.44051 17.5865 2.1533 17.395C1.8661 17.2036 1.78849 16.8155 1.97996 16.5283Z" fill="black" fill-opacity="0.9"/>
// </svg>
// `,
//         },
      ],
			allowOrgList:['0fec3a8a-ad04-11ed-b13d-005056b86db5',"b50cf65a-001c-11ee-91d8-005056b86db5"],
			allowOidList:['45facc0a-1211-11ec-80ad-005056b86db5'],
			// studentSpace:["7cc601a0-fafc-4116-a805-0adbacf7a38d","0fec3a8a-ad04-11ed-b13d-005056b86db5","b50cf65a-001c-11ee-91d8-005056b86db5","45facc0a-1211-11ec-80ad-005056b86db5","16ace517-b5c7-4168-a9bb-a9e0035df840","3823a6a5-1b6e-11f0-a66a-005056924926","c25ea59b-1b6d-11f0-a66a-005056924926","d87b62d3-1b6d-11f0-a66a-005056924926","f235659b-1b6d-11f0-a66a-005056924926","1197f86b-1b6e-11f0-a66a-005056924926","1a1a172d-1b6e-11f0-a66a-005056924926","292e34dc-1b6e-11f0-a66a-005056924926","21d6b367-1b6e-11f0-a66a-005056924926","0df61e4c-fe2d-11ef-b508-005056924926","23bbe712-e35a-4888-9b4e-8d9e5a4fa2f6"],
			// teacherSpace:["0fec3a8a-ad04-11ed-b13d-005056b86db5","b50cf65a-001c-11ee-91d8-005056b86db5","45facc0a-1211-11ec-80ad-005056b86db5","16ace517-b5c7-4168-a9bb-a9e0035df840","2cf7d6ab-c5f9-11f0-a424-005056924926","3823a6a5-1b6e-11f0-a66a-005056924926","c25ea59b-1b6d-11f0-a66a-005056924926","d87b62d3-1b6d-11f0-a66a-005056924926","f235659b-1b6d-11f0-a66a-005056924926","1197f86b-1b6e-11f0-a66a-005056924926","1a1a172d-1b6e-11f0-a66a-005056924926","292e34dc-1b6e-11f0-a66a-005056924926","21d6b367-1b6e-11f0-a66a-005056924926","0df61e4c-fe2d-11ef-b508-005056924926","23bbe712-e35a-4888-9b4e-8d9e5a4fa2f6"],
      studentSpace:[],
      teacherSpace:[],
      controlsObj:null,
      islogout: false,
      org: '',//16ace517-b5c7-4168-a9bb-a9e0035df840
      isReturn: false,
      USER_TYPE_CONSTANTS: USER_TYPE_CONSTANTS
    };
  },
  mounted() {
		this.getAppStoreControl()
    this.getStudentSpaceOrgOidList()
    this.getTeacherSpaceOrgOidList()
    this.$nextTick(() => {
      if(parent.location.href.includes("iframe")){
        this.islogout = true
      }
      if(this.$route.query.gotype == 1){
        this.isReturn = true
      }
    })
    console.log(this.user)
	},
  methods: {
    checkTab(item){
      if(item.value == 4){
        this.addOp3(1, "", {id: item.id, name: item.muti_name, type: 'open_teaching_mode'}, "success")
      }else if(item.value == 5){
        this.addOp3(1, "", {id: item.id, name: item.muti_name, type: 'open_learning_mode'}, "success")
      }
      this.$emit('handle_active_type_tab',item.value)
    },
    handle_change_orgArea(value){
      this.bus.$emit('handle_change_orgArea',value)
    },
		getAppStoreControl(){
			let controlsObj = {
        logoUrl: "https://ccrb.s3.cn-northwest-1.amazonaws.com.cn/default%2FFrame+4273197481741333327961.png",
        bannerUrl:"https://ccrb.s3.cn-northwest-1.amazonaws.com.cn/default%2FFrame+30141733970358224.svg",
        exportTypeList: []
      };
			this.$axios
        .get(
          `https://pbl.cocorobo.cn/api/pbl/select_appStore_controls?uid=${this.user.userId}&oid=${this.user.organizeid}&org=${this.user.org}`
					// `https://pbl.cocorobo.cn/api/pbl/select_appStore_controls?uid=6c56ec0e-2c74-11ef-bee5-005056b86db5&oid=&org=f3b243b2-75e2-4b00-8f66-7644946a2a25`
        )
        .then((res) => {
					let _data = res.data[0];
            if (_data[0]) {
              controlsObj = JSON.parse(_data[0].json);
            }
            this.controlsObj = controlsObj;
          })
          .catch(err => {
            console.log(err)
            this.controlsObj = controlsObj;
          });

		},
    async returnLiyuan(){
      let userJson
      try {
				userJson = await this.ajax.get(this.$store.state.api + "selectUser", { userid: this.$store.state.user.userId });
			} catch (e) {
				console.log(e);
				return this.returnLiyuan()
			}
      console.log(userJson)
      if (window.location.href.includes("beta")) {
        window.location.href = `//beta.pbl.cocorobo.cn/pbl-teacher-table/dist/#/CourseCon?userid=${this.$store.state.user.userId}&oid=${this.$store.state.user.organizeid}&org=${this.$store.state.user.org}&tType=${userJson.data[0][0].type}&role=${userJson.data[0][0].role}`
      } else {
        window.location.href = `//pbl.cocorobo.cn/pbl-teacher-table/dist/#/CourseCon?userid=${this.$store.state.user.userId}&oid=${this.$store.state.user.organizeid}&org=${this.$store.state.user.org}&tType=${userJson.data[0][0].type}&role=${userJson.data[0][0].role}`
      }
    },
    logout(){
      parent.U.MD.U.LO.logoutSystem()
    },
    getStudentSpaceOrgOidList(){
      this.ajax.get(this.$store.state.api + "select_ClassByParentid", { pid: 16 }).then(res => {
        const _result = res.data[0]
        if(_result){
          this.studentSpace = _result.map(i=>i.oid);
        }
      })
    },
    getTeacherSpaceOrgOidList(){
      this.ajax.get(this.$store.state.api + "select_ClassByParentid", { pid: 15 }).then(res => {
        const _result = res.data[0]
        if(_result){
          this.teacherSpace = _result.map(i=>i.oid)
        }
      })
    },
  },
};
</script>
<style scoped>
.location_select >>> .el-input__inner{
  border: none;
}
.header {
  height: 50px;
	min-height: 50px;
	max-height: 50px;
  position: relative;
	box-sizing: border-box;
  border-bottom: 1px solid #ccc;
  background: #fff;
	display: flex;
	align-items: center;
}
.logo {
  position: absolute;
  left: 20px;
  /* top: 0; */
  height: 30px;
}
.location{
  position: absolute;
  right: 20px;
}
.tabItem{
	display: flex;
	align-items: center;
	margin-right: 10px;
}

.tabItem>img{
	width: 22px;
	height: 22px;
	position: relative;
	top: 1px;
	margin-right: 10px;
}

.tabItem>div{
	height: 20px;
	display: flex;
	align-items: center;
}

.logout_btn{
  color: #000;
  cursor: pointer;
  margin: 0 15px;
}
.r_pub_button_retrun {
  color: #0061FF;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.r_pub_button_retrun::before {
  content: "";
  width: 14px;
  height: 14px;
  min-width: 14px;
  min-height: 14px;
  background-size: 100% 100%;
  display: block;
  margin-right: 7px;
  background-image: url(../../assets/img/logos/d86be6415da231fde1fb16b20758cd1.png);
}
</style>
